import styled from 'styled-components';

export const CustomerSupport = styled.a`
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
`;
